module.exports = __webpack_public_path__ + "static/img/grade_2.baded05.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/oralT/img/grade_2.png
// module id = yXXz
// module chunks = 89